import React, {FunctionComponent} from "react";
import {Redirect, RouteComponentProps} from "@reach/router";
import {useAuthState} from "./provider";
import {LoginForm} from "./loginForm";

export const LoginPage: FunctionComponent<RouteComponentProps> = (props) => {
  const {isLoggedIn} = useAuthState();
  return isLoggedIn ? <Redirect to="/" noThrow/> : <LoginForm {...props}/>;
}
